import type { ReactNode } from 'react';
import { cn } from '@/utils/сn';

interface CardListProps<T> {
  items: T[];
  getKey: (item: T, index: number) => string | number;
  renderCard: (item: T, index: number) => ReactNode;
  className?: string;
}

export const CardList = <T,>({ items, getKey, renderCard, className }: CardListProps<T>) => {
  if (!items.length) return null;

  return (
    <ul className={cn('flex flex-col gap-3', className)}>
      {items.map((item, index) => (
        <li key={getKey(item, index)}>{renderCard(item, index)}</li>
      ))}
    </ul>
  );
};
